module.exports = __webpack_public_path__ + "static/img/introduce2.0417c9e4.png";